// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1oc37","footer":"ReportModalFilter_footer__1zGHO"};